export * from '@fhs/routing/src/routes/v2/menu/_layout';
export { default } from '@fhs/routing/src/routes/v2/menu/_layout';
